import { render, staticRenderFns } from "./BigMap.vue?vue&type=template&id=1446c582&scoped=true"
import script from "./BigMap.vue?vue&type=script&lang=js"
export * from "./BigMap.vue?vue&type=script&lang=js"
import style0 from "./BigMap.vue?vue&type=style&index=0&id=1446c582&prod&lang=css"
import style1 from "./BigMap.vue?vue&type=style&index=1&id=1446c582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1446c582",
  null
  
)

export default component.exports